export abstract class DateController {
  timeFrom: Date;
  timeTo: Date;
  date: Date;

  constructor($scope: ng.IScope) {
    this.date = new Date();

    $scope.$watch('ctrl.timeFrom', (val: Date) => {
      console.log('from', this.date, val);
      if (this.date && val) {
        this.fromChanged(this.calculate(this.date, val));
      } else {
        this.fromChanged(null);
      }
    });

    $scope.$watch('ctrl.timeTo', (val: Date) => {
      console.log('to', this.date, val);
      if (this.date && val) {
        this.toChanged(this.calculate(this.date, val));
      } else {
        this.toChanged(null);
      }
    });

    $scope.$watch('ctrl.date', (val: Date) => {
      if (this.timeFrom && val) {
        this.fromChanged(this.calculate(val, this.timeFrom));
      } else {
        this.fromChanged(null);
      }

      if (this.timeTo && val) {
        this.toChanged(this.calculate(val, this.timeTo));
      } else {
        this.toChanged(null);
      }
    });

  }

  calculate(date: Date, time: Date) {
    const newDate = new Date(date.getTime());
    newDate.setHours(time.getHours(), time.getMinutes(), 0, 0);
    return newDate;
  }

  abstract fromChanged(date: Date): void;
  abstract toChanged(date: Date): void;
}